export enum CookCategoryEnum {
    PREMIUM = "Premium",
    POPULAR = "Popular"
}

export enum NewLeadCategoryEnum {
    PREMIUM = "Premium",
    POPULAR = "Popular",
    ECONOMY = "Economy"
}